module.exports = __webpack_public_path__ + "static/img/live-uid.6376b529.jpg";